import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { IS_PWA } from 'react-easyrocket';
import { shieldInit } from 'react-easyrocket/shield';
import { initializeGtm } from './hooks/useAddGtm';
import { App } from './App';
import { isDev, isProductionEnv } from './api';
import {
  handleMirrorsSwRegistration,
  unregisterMirrorsServiceWorker
} from './utils/dnsSpooferScript';
import { addVitePreloadErrorHandler } from './utils/preloadRetry';
import { unregisterOldServiceWorkers } from './utils/unregisterOldServiceWorkers';
import './index.css';
import { smarticoInit } from './utils/smartico';
import { smartlookInit, smartlookRecordNumbers } from 'src/modules/smartlook';
import { checkAndSetPwaBasename } from './utils/pwa';

unregisterOldServiceWorkers();
initializeGtm({ isProductionEnv, gtmId: 'GTM-5HQ77XW3' });
smarticoInit();
addVitePreloadErrorHandler();
checkAndSetPwaBasename();
shieldInit();
handleMirrorsSwRegistration(!isDev && isProductionEnv);
unregisterMirrorsServiceWorker();

if (isProductionEnv) {
  smartlookInit();
  smartlookRecordNumbers();
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <BrowserRouter basename={IS_PWA ? '/pwa' : undefined}>
    <App />
  </BrowserRouter>
);
